// src/admin/pages/PageEditor.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../utils/axios";
import SectionEditor from "./SectionEditor";
import SectionCreateForm from "./SectionCreateForm";
import PagePreview from "./PagePreview";

function PageEditor() {
  const { id } = useParams();
  const [page, setPage] = useState(null);
  const [sections, setSections] = useState([]);
  const [showCreateSection, setShowCreateSection] = useState(false);
  const [previewSections, setPreviewSections] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const load = async () => {
    const pageRes = await api.get(`/pages/${id}`);
    const page = pageRes.data.data;

    let renderUrl;

    if (page.route_path === "/") {
      renderUrl = "/render-home";
    } else {
      const cleanPath = page.route_path.replace(/^\/+/, "");
      renderUrl = `/render-page/${cleanPath}`;
    }

    const renderRes = await api.get(renderUrl);

    setPage(page);
    setSections(renderRes.data.data.sections || []);
    setPreviewSections(renderRes.data.data.sections || []);
  };

  useEffect(() => {
    load();
    }, [id]);

  const deleteSection = async (sectionId) => {
    if (!window.confirm("Delete this section?")) return;
    await api.delete(`/sections/${sectionId}`);
    load();
  };

  if (!page) return <p>Loading...</p>;

  return (
      <div>
        <h2>Edit Page: {page?.title}</h2>

        <button className={"button"} style={{marginRight:"10px"}} onClick={() => setShowPreview((prev) => !prev)}>
          {showPreview ? "Hide Preview" : "Show Preview"}
        </button>

        {showPreview && (
            <PagePreview
                page={page}
                sections={previewSections}
            />
        )}

        <button className={"button"} onClick={() => setShowCreateSection((prev) => !prev)}>
          {showCreateSection ? "Cancel" : "+ Add Section"}
        </button>

        {showCreateSection && (
            <SectionCreateForm
                pageId={page.id}
                existingSections={sections}
                onCreated={() => {
                  load();
                  setShowCreateSection(false);
                }}
            />
        )}

        <hr />

        <h3>Main sections</h3>
        {sections
            .filter((s) => s.zone === "main")
            .map((section) => (
                <div key={section.id} className="admin-card">
                  <h4>
                    {section.section_name} — {section.section_type} — order{" "}
                    {section.sort_order}
                  </h4>

                  <button onClick={() => deleteSection(section.id)}>
                    Delete Section
                  </button>

                  <SectionEditor
                      section={section}
                      refresh={load}
                      onPreviewChange={(updatedSection) => {
                        setPreviewSections((prev) =>
                            prev.map((s) =>
                                s.id === updatedSection.id ? updatedSection : s
                            )
                        );
                      }}
                  />
                </div>
            ))}

        <h3>Sidebar sections</h3>
        {sections
            .filter((s) => s.zone === "sidebar")
            .map((section) => (
                <div key={section.id} className="admin-card">
                  <h4>
                    {section.section_name} — {section.section_type} — order{" "}
                    {section.sort_order}
                  </h4>


                  <button className={"button"} onClick={() => deleteSection(section.id)}>
                    Delete Section
                  </button>

                  <SectionEditor
                      section={section}
                      refresh={load}
                      onPreviewChange={(updatedSection) => {
                        setPreviewSections((prev) =>
                            prev.map((s) =>
                                s.id === updatedSection.id ? updatedSection : s
                            )
                        );
                      }}
                  />
                </div>
            ))}
      </div>
  );
}

export default PageEditor;